import { render } from "./LicenseForm.vue?vue&type=template&id=a2dfed72&scoped=true"
import script from "./LicenseForm.vue?vue&type=script&lang=js"
export * from "./LicenseForm.vue?vue&type=script&lang=js"

import "./LicenseForm.vue?vue&type=style&index=0&id=a2dfed72&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2dfed72"]])

export default __exports__